import type { NavigateFunction } from 'react-router-dom'

// Service worker → app bridge. The SW's notificationclick handler posts
// { type: 'navigate', url } when it focuses an existing Pantry tab; this
// handler picks it up and routes via React Router instead of forcing a
// full reload, which would lose the SPA's in-memory state.
//
// The listener is attached at most once, but `currentNavigate` is updated
// on every call so the captured navigate never goes stale across remounts
// or hot reloads.

let currentNavigate: NavigateFunction | null = null
let attached = false

export function initSwMessageHandler(navigate: NavigateFunction): void {
  currentNavigate = navigate

  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return
  if (attached) return
  attached = true

  navigator.serviceWorker.addEventListener('message', (event: MessageEvent) => {
    const data = event.data
    if (data && data.type === 'navigate' && typeof data.url === 'string') {
      currentNavigate?.(data.url)
    }
  })
}
